export enum ExportDataMethod {
  File = 'File',
  Clipboard = 'ClipBoard',
}
